import { opacity } from "utils/canvas";
import { Color } from "utils/theme";

// Main arc styles
export const MAIN_ARC_BG = Color.Primary[700];
export const MAIN_ARC_STROKE = opacity(Color.Primary[600], 0.8);

// Outer arc styles
export const OUTER_ARC_BG = Color.Primary[800];
export const OUTER_ARC_STROKE = Color.Primary[800];

export const DEFAULT_TICK_COLOR = opacity(Color.Primary[500], 0.6);
